"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindUserServiceStrategyEnum = void 0;
var FindUserServiceStrategyEnum;
(function (FindUserServiceStrategyEnum) {
  /**
   * Поиск строго по id
   * required: IFindUserServicesFilter.id
   */
  FindUserServiceStrategyEnum["id"] = "id";
  /**
   * Поиск для конструктора - все для конкретного автора = текущего пользователя
   */
  FindUserServiceStrategyEnum["owned"] = "owned";
  /**
   * Поиск для библиотеки = промодерированные публичные
   */
  FindUserServiceStrategyEnum["library"] = "library";
  /**
   * Поиск для профиля пользователя
   * required: IFindUserServicesFilter.author_id
   */
  FindUserServiceStrategyEnum["profile"] = "profile";
  /**
   * Поиск в избранном - всё, что пользователь user_id добавил в избранное
   * required: ctx.state.user.id
   */
  FindUserServiceStrategyEnum["favorites"] = "favorites";
  /**
   * Поиск для конструктора - все для конкретной школы
   * required: IFindUserServicesFilter.school_id
   */
  FindUserServiceStrategyEnum["school_owned"] = "school_owned";
  /**
   * Поиск для профиля школы
   * required: IFindUserServicesFilter.school_id
   */
  FindUserServiceStrategyEnum["school"] = "school";
  /**
   * Поиск услуг, назначенных на преподавателя в школе
   * optional: IFindUserServicesFilter.school_id
   * required: IFindUserServicesFilter.teacher_id
   */
  FindUserServiceStrategyEnum["school_teaching"] = "school_teaching";
})(FindUserServiceStrategyEnum = exports.FindUserServiceStrategyEnum || (exports.FindUserServiceStrategyEnum = {}));
